import React, { useState } from 'react';

import { Carousel as MobileCarousel } from 'react-responsive-carousel';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Button } from 'fpay-ui';

import { useConfig } from '@hooks';
import { useHistory } from 'react-router-dom';
import { getConfigMerchantType } from 'helpers';
import UserCard from '../Cards/UserCard';
import Text from '../Text';
import useBreakpoint from '../../hooks/breakpoint';
import { breakpoint } from '../../constants/styles';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { getHtmlIdUserCard } from '../../helpers/getHtmlId';
import { useAuth } from '@hooks';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  padding: 24px;
  border-radius: 6px;
  background-color: #ffffff;
  ${breakpoint('large')`
    max-width: 1016px;
    height: auto;
    padding: 32px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 20px
  `}
`;

const Title = styled(Text)`
  margin-bottom: 20px;
`;
const StyledDiv = styled.div`
  button {
    padding: 15px 25px;
    width: calc(50% - 10px);
    &:first-child {
      margin-right: 20px;
    }
  }
  ${({ theme }) => theme.breakpoint('md')} {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    button {
      width: auto;
      padding: 7px 25px;
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`;

const MobileCarouselStyled = styled(MobileCarousel)`
  margin-top: 14px;
  & .carousel-slider {
    overflow: visible;
    .slide {
      background: #fff;
      padding-bottom: 50px;
      &:nth-child(2) {
        padding: 0 10px;
      }
    }
    .control-dots {
      bottom: 5px;
      .dot {
        background: #caced8;
        box-shadow: none;
        &.selected {
          background: #43b22a;
        }
      }
    }
  }
`;

const Carousel = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  overflow-x: auto;
  ${({ theme }) => theme.breakpoint('lg')} {
    overflow-x: hidden;
  }
  margin-top: 24px;
  > div {
    &:last-child {
      margin-right: 0px;
    }
  }
  ${breakpoint('medium')`
    margin-top: 32px;
  `}
`;

const UserInviteRoles = ({ handleClick, edit, selection, prevSelection }) => {
  const { t } = useTranslation();
  const { mobile } = useBreakpoint();
  const history = useHistory();
  const [newSelection, setNewSelection] = useState(prevSelection || selection);

  const handleInterceptor = (card) => {
    setNewSelection(card.name);
  };

  const canSelectRole = (currentRoles, targetRole, isOnusorSeller) => {
    const hierarchy = isOnusorSeller ? roleHierarchy.onus : roleHierarchy.nonOnus;
    return currentRoles.some((currentRole) => hierarchy[currentRole] <= hierarchy[targetRole]);
  };

  const { isOnus, roles: myRol } = useAuth();
  const { config = {} } = useConfig();
  const { roles = [] } = config;
  const cards = roles[getConfigMerchantType()] ?? [];

  const roleHierarchy = {
    onus: {
      'SUPER-ADMIN-ONUS': 1,
      'ADMIN-ONUS': 2,
      ONUS: 3,
      'ANALISTA-ONUS': 4,
    },
    nonOnus: {
      ADMIN: 1,
      LEGAL_REPRESENTATIVE: 1,
      'ADMIN-SECONDARY': 2,
      SELLER: 3,
    },
  };

  // Filtrar las cards según el rol
  const filteredCards = cards.filter((card) => canSelectRole(myRol, card.name, isOnus));

  console.log('ROL', myRol);
  console.log('ROLES', roles);

  return (
    <Container>
      {!mobile && (
        <Title type="H6-w400" color="gray800">
          {edit
            ? t('Onboarding.editRole.title')
            : t('Onboarding.MerchantOnboarding.userInviteRoles.title')}
        </Title>
      )}
      <Text type="Subtitle-1-w400" color="gray700">
        {t('Onboarding.MerchantOnboarding.userInviteRoles.subtitle')}
      </Text>
      {!mobile ? (
        <>
          <Carousel>
            {filteredCards.map((card, key) => (
              <UserCard
                htmlIdCard={getHtmlIdUserCard(card.name)}
                card={card}
                selection={newSelection}
                handleClick={handleInterceptor}
                key={key}
              />
            ))}
          </Carousel>
          <StyledDiv>
            <Button
              id="cancel-collaborator-invitation-roles"
              size="medium"
              type="outlined"
              onClick={() => history.goBack()}
            >
              {edit ? t('common.buttonCancel') : t('common.buttonBack')}
            </Button>
            <Button
              id="confirm-collaborator-invitation-roles"
              size="medium"
              onClick={() => handleClick(newSelection)}
              disabled={selection === newSelection}
            >
              {t('common.buttonNext')}
            </Button>
          </StyledDiv>
        </>
      ) : (
        <>
          <MobileCarouselStyled
            centerMode
            centerSlidePercentage={80}
            mobile={mobile}
            showArrows={false}
            showIndicators
            showThumbs={false}
            showStatus={false}
          >
            {filteredCards.map((card, key) => (
              <UserCard
                htmlIdCard={getHtmlIdUserCard(card.name)}
                card={card}
                key={key}
                selection={newSelection}
                handleClick={handleInterceptor}
              />
            ))}
          </MobileCarouselStyled>
          <StyledDiv>
            <Button
              size="medium"
              type="outlined"
              onClick={() => history.goBack()}
              id="cancel-collaborator-invitation-roles"
            >
              {edit ? t('common.buttonCancel') : t('common.buttonBack')}
            </Button>
            <Button
              size="medium"
              onClick={() => handleClick(newSelection)}
              disabled={selection === newSelection}
              id="confirm-collaborator-invitation-roles"
            >
              {t('common.buttonNext')}
            </Button>
          </StyledDiv>
        </>
      )}
    </Container>
  );
};

export default UserInviteRoles;
